module.exports = __webpack_public_path__ + "static/media/up.bb359774.jpg";